module.exports = __webpack_public_path__ + "img/menu04.e1d03a53.svg";